import React from 'react';
import { Award, Globe, TrendingUp } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" style={styles.section} className="about-section">
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title} className="about-title">À Propos de Nahhas Luxury Consulting</h2>
          <p style={styles.subtitle} className="about-subtitle">
            Votre partenaire d'excellence pour des projets d'envergure dans l'univers du luxe
          </p>
        </div>

        <div style={styles.content} className="about-content">
          <div style={styles.imageSection}>
            <img 
              src="https://images.pexels.com/photos/931887/pexels-photo-931887.jpeg"
              alt="Luxury office"
              style={styles.image}
              className="about-image"
            />
          </div>

          <div style={styles.textSection}>
            <p style={styles.description}>
              Nahhas Luxury Consulting est une agence de conseil premium spécialisée dans trois secteurs stratégiques du luxe : l'hospitalité haut de gamme, l'immobilier d'exception et les investissements sophistiqués.
            </p>
            <p style={styles.description}>
              Notre expertise approfondie et notre réseau international nous permettent d'accompagner nos clients dans leurs projets les plus ambitieux, en garantissant excellence et rentabilité.
            </p>

            <div style={styles.stats} className="about-stats">
              <div style={styles.stat}>
                <Award size={32} style={styles.icon} />
                <h3 style={styles.statNumber}>3+</h3>
                <p style={styles.statLabel}>Années d'Expertise</p>
              </div>
              <div style={styles.stat}>
                <Globe size={32} style={styles.icon} />
                <h3 style={styles.statNumber}>20+</h3>
                <p style={styles.statLabel}>Projets Réalisés</p>
              </div>
              <div style={styles.stat}>
                <TrendingUp size={32} style={styles.icon} />
                <h3 style={styles.statNumber}>100M€+</h3>
                <p style={styles.statLabel}>Valeur Gérée</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '120px 40px',
    background: '#000000',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '80px',
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: '24px',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '20px',
    color: 'rgba(255, 255, 255, 0.7)',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: '1.6',
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '60px',
    alignItems: 'center',
  },
  imageSection: {
    position: 'relative',
  },
  image: {
    width: '100%',
    height: '600px',
    objectFit: 'cover',
    border: '2px solid rgba(212, 175, 55, 0.3)',
  },
  textSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  description: {
    fontSize: '18px',
    lineHeight: '1.8',
    color: 'rgba(255, 255, 255, 0.85)',
  },
  stats: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '40px',
    marginTop: '40px',
  },
  stat: {
    textAlign: 'center',
  },
  icon: {
    color: '#D4AF37',
    marginBottom: '16px',
  },
  statNumber: {
    fontSize: '36px',
    fontWeight: '700',
    color: '#D4AF37',
    marginBottom: '8px',
  },
  statLabel: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
};

// Add responsive styles
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @media (max-width: 768px) {
    .about-section {
      padding: 60px 20px !important;
    }
    .about-title {
      font-size: 32px !important;
    }
    .about-subtitle {
      font-size: 16px !important;
    }
    .about-content {
      grid-template-columns: 1fr !important;
      gap: 40px !important;
    }
    .about-image {
      height: 300px !important;
    }
    .about-stats {
      grid-template-columns: 1fr !important;
      gap: 24px !important;
    }
  }
`;
document.head.appendChild(styleSheet);